import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";

export const Table = ({ columns, classes, items, keyField }) => (
  <>
    <TableHeader columns={columns} classes={classes} />
    {items.map((item, index) => (
      <TableRow
        key={item[keyField] ?? index}
        data={item}
        columns={columns}
        classes={classes}
        keyField={keyField}
      />
    ))}
  </>
);

export const TableHeader = ({ columns, classes }) => (
  <Grid item md={12} sm={12} xs={12} className={classes.clickTableRow}>
    <Grid container spacing={2} className={classes.clickTableRowInner}>
      {columns.map((column, index) => (
        <Grid
          key={index}
          item
          xs={column.xs}
          sm={column.sm}
          md={column.md}
          className={
            index === 0
              ? classes.outboundClickUrlContainer
              : classes.outboundClickValueContainer
          }
        >
          {column.label}
        </Grid>
      ))}
    </Grid>
  </Grid>
);

export const TableRow = ({ data, columns, classes, keyField }) => (
  <Grid
    item
    md={12}
    sm={12}
    xs={12}
    className={classes.clickTableRow}
    key={data[keyField]}
  >
    <Grid container spacing={2} className={classes.clickTableRowInner}>
      {columns.map((column, index) => (
        <Grid
          key={index}
          item
          xs={column.xs}
          sm={column.sm}
          md={column.md}
          className={
            index === 0
              ? classes.outboundClickUrlContainer
              : classes.outboundClickValueContainer
          }
        >
          {column.render ? column.render(data) : data[column.field]}
        </Grid>
      ))}
    </Grid>
  </Grid>
);
